module.exports = __webpack_public_path__ + "static/media/no-mat.98e9b9de.jpg";